export default {"src":"/_next/static/media/0xd2671165570f41bbb3b0097893300b6eb6101e6c.0f3aff76.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};